<template>
  <div class="chat-container">
    <div class="chat-header">
      <h1>PORTAL API - ASSISTENTE VIRTUAL</h1>
    </div>
    <div class="chat-body" ref="chatBody">
      <div v-for="(msg, index) in messages" :key="index" :class="['chat-bubble', msg.type]">
        <img class="avatar" :src="msg.avatar" alt="avatar" />
        <div class="bubble-content" style="white-space: pre-line;">
          <template v-if="msg.loading">
            <div class="loader">
              <span></span><span></span><span></span>
            </div>
          </template>
          <template v-else>
            <div v-html="msg.text"></div>
          </template>
        </div>
        <div v-if="showFeedback(msg, index)" class="star-rating">
          <label v-for="star in [5, 4, 3, 2, 1]" :key="star" class="star">
            <input type="radio" :name="`rating-${index}`" :value="star" v-model="msg.rating" @change="onRate(msg)" />
            <span></span>
          </label>
        </div>
      </div>
    </div>
    <div class="chat-footer">
      <input type="text" v-model="userInput" @keyup.enter="sendMessage" placeholder="Escreva sua pergunta..." :disabled="isLoading" />
      <button @click="sendMessage" :disabled="isLoading">
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api-area-logada/img/icon-send.svg">
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Chat',
  data() {
    const avatars = {
      user: '/massificados/corporativo/gerenciador-parceiros-ui/portal-api-area-logada/img/user.svg',
      bot: '/massificados/corporativo/gerenciador-parceiros-ui/portal-api-area-logada/img/bot.svg',
    }

    return {
      avatars,
      messages: [
        {
          text: 'Oiê! Sou o assistente virtual do Portal API e estou sempre online pra você. E aí, o que você precisa saber hoje?',
          type: 'answer',
          avatar: avatars.bot
        }
      ],
      userInput: '',
      uniqueID: '',
      chat: []
    }
  },

  computed: {
    isLoading() {
      return this.messages.some(msg => msg.loading)
    }
  },

  mounted() {
    this.getUniqueID()
  },

  methods: {

    async getUniqueID() {
      const response = await axios.get("/massificados/corporativo/gerenciador-parceiros/rest/ia/obter-unique-id");
      this.uniqueID = response.data;
    },

    async sendMessage() {
      if (!this.userInput.trim()) return
      const questionText = this.userInput

      this.messages.push({
        text: questionText,
        type: 'question',
        avatar: this.avatars.user
      })

      this.userInput = ''

      const loaderIndex = this.messages.push({
        loading: true,
        type: 'answer',
        avatar: this.avatars.bot,
      }) - 1

      this.scrollToBottom();

      try {
        const url = `/massificados/corporativo/gerenciador-parceiros/rest/ia/consultar/${this.uniqueID}`
        const res = await axios.post(url, { question: questionText })

        const formatted = this.formatString(res.data)
        // console.log(formatted.answer)

        this.$set(this.messages, loaderIndex, {
          text: (formatted && formatted.answer) ? formatted.answer : 'Sem resposta interpretável.',
          type: 'answer',
          avatar: this.avatars.bot,
          loading: false,
        })
      } catch (err) {
        console.error('Erro ao obter resposta:', err)

        // tenta capturar mensagem do backend, se existir
        const errorMsg =
          (err && err.response && err.response.data && err.response.data.error) ||
          (err && err.error) ||
          (err && err.message) ||
          ''
        // const finalMsg = 'Erro ao obter resposta.' + (errorMsg ? '\nDetalhe: ' + errorMsg : '')
        const finalMsg = 'Erro ao obter resposta, favor formular outra pergunta.'

        this.$set(this.messages, loaderIndex, {
          text: finalMsg.replace(/\n/g, '<br>'),
          type: 'answer',
          avatar: this.avatars.bot,
          loading: false
        })
      } finally {
        this.scrollToBottom();
      }
    },

    showFeedback(msg, index) {
      if (
        msg.type !== 'answer' ||
        msg.loading ||
        msg.rated ||
        index === 0
      ) {
        return false
      }

      for (var j = index + 1; j < this.messages.length; j++) {
        if (this.messages[j].isSystemMessage) {
          return false
        }
      }

      var lastAnswerIndex = -1

      for (var i = this.messages.length - 1; i >= 0; i--) {
        var m = this.messages[i]

        if (
          m.type === 'answer' &&
          !m.isSystemMessage &&
          !m.rated
        ) {
          lastAnswerIndex = i
          break
        }
      }
      return index === lastAnswerIndex
    },

    async onRate(msg) {
      const chat = []

      for (let i = 0; i < this.messages.length; i++) {
        const msg = this.messages[i]

        if (msg.type === 'answer') {

          const question = this.messages
            .slice(0, i)
            .reverse()
            .find(m => m.type === 'question')

          if (question) {
            chat.push({
              classificacao: msg.rating || null,
              pergunta: question.text,
              resposta: this.stripHtml(msg.text)
            })
          }
        }
      }
      this.scrollToBottom();
      const payload = { chat }
      
      try {
        const url = `/massificados/corporativo/gerenciador-parceiros/rest/ia/classificar/${this.uniqueID}`
        const res = await axios.post(url, payload)

        msg.rated = true
        this.messages.push({
          text: 'Muito obrigado! Seu feedback é essencial para o meu aprendizado contínuo e para melhorar a qualidade das minhas respostas.',
          type: 'answer',
          avatar: this.avatars.bot,
          isSystemMessage: true
        })
        // console.log(JSON.stringify(payload, null, 2))
      } catch (error) {
        console.error('Erro ao enviar feedback', error)
      } finally {
       this.scrollToBottom();
      }

    },

    stripHtml(html) {
      if (!html) return ''

      let text = html
        // troca <br> por quebra de linha
        .replace(/<br\s*\/?>/gi, '\n')
        // remove tags HTML
        .replace(/<[^>]*>/g, '')
        // remove aspas duplas
        .replace(/"/g, '')
        // remove TODAS as quebras de linha
        .replace(/\n+/g, ' ')
        // normaliza espaços
        .replace(/\s{2,}/g, ' ')
        .trim()

      return text
    },

    scrollToBottom() {
      this.$nextTick(() => {
      const el = this.$refs.chatBody
      if (el) {
        el.scrollTop = el.scrollHeight
      }
    })
    },

    formatString(responseKendra) {
      try {
        let cleaned = responseKendra

        // Corrige aspas simples das chaves e nomes para JSON válido
        cleaned = cleaned.replace(/([{,]\s*)'([^']+?)'\s*:/g, '$1"$2":')

        // Decodifica strings com prefixo b'...' para UTF-8, escapando adequadamente
        cleaned = cleaned.replace(/b'((?:[^'\\]|\\.)*?)'/g, (_, byteStr) => {
          const decoded = this.decodeByteString(byteStr)
          return `"${this.escapeStringForJSON(decoded)}"`
        })

        // Corrige aspas simples em valores string para aspas duplas JSON
        cleaned = cleaned.replace(/:\s*'((?:[^'\\]|\\.)*?)'/g, (_, val) => {
          return `:"${this.escapeStringForJSON(val)}"`
        })

        // Substitui escapes \xHH inválidos por \u00HH válidos em JSON
        cleaned = cleaned.replace(/\\x([0-9A-Fa-f]{2})/g, (_, hex) => {
          return `\\u00${hex.toUpperCase()}`
        })

        // Mantém as quebras de linha como <br> (para exibir no HTML)
        cleaned = cleaned.replace(/\\n/g, '<br>')

        // Remove barras invertidas inválidas
        cleaned = cleaned.replace(/\\(?![\\ntrbu"'])/g, '')

        const obj = JSON.parse(cleaned)
        // console.log(obj)
        return obj
      } catch (err) {
        console.error('Erro ao converter string para JSON:', err)
        console.log('Conteúdo problemático:', responseKendra)
        return null
      }
    },

    escapeStringForJSON(val) {
      return val
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"')
        .replace(/\n/g, '\\n')
        .replace(/\r/g, '\\r')
        .replace(/\t/g, '\\t')
    },

    decodeByteString(byteStr) {
      const bytes = []
      for (let i = 0; i < byteStr.length; i++) {
        if (byteStr[i] === '\\' && byteStr[i + 1] === 'x') {
          const hex = byteStr.slice(i + 2, i + 4)
          bytes.push(parseInt(hex, 16))
          i += 3
        } else if (byteStr[i] === '\\' && byteStr[i + 1] === "'") {
          bytes.push("'".charCodeAt(0))
          i += 1
        } else {
          bytes.push(byteStr.charCodeAt(i))
        }
      }
      return new TextDecoder('utf-8').decode(new Uint8Array(bytes))
    }
  }
}

</script>

<style scoped>
@font-face {
  font-family: 'Titillium Web';
  src: url('/massificados/corporativo/gerenciador-parceiros-ui/portal-api-area-logada/css/fonts/TitilliumWeb-SemiBold.woff2') format('woff2'),
    url('/massificados/corporativo/gerenciador-parceiros-ui/portal-api-area-logada/css/fonts/TitilliumWeb-SemiBold.woff') format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Titillium Web';
  src: url('/massificados/corporativo/gerenciador-parceiros-ui/portal-api-area-logada/css/fonts/TitilliumWeb-Regular.woff2') format('woff2'),
    url('/massificados/corporativo/gerenciador-parceiros-ui/portal-api-area-logada/css/fonts/TitilliumWeb-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.chat-container {
  font-family: 'Titillium Web' !important;
  display: flex;
  flex-direction: column;
}

.chat-header {
  background: transparent linear-gradient(270deg, #e8dd80 0, #009074 100%);
  color: #fff;
  text-align: center;
  padding: 1rem;
}

.chat-header h1 {
  font-size: 1rem;
  margin: 0;
}

.chat-body {
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: 1rem;
  height: 75vh;
}

.chat-bubble {
  display: flex;
  align-items: flex-end;
  position: relative;

}

.chat-bubble.question {
  align-self: flex-end;
  flex-direction: row-reverse;
  margin-left: 1rem;
  max-width: 90%;
}

.chat-bubble.answer {
  align-self: flex-start;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.bubble-content {
  padding: 10px 14px;
  position: relative;
  isolation: isolate;
}

.chat-bubble.answer .bubble-content {
  background: #eee;
  border-radius: 15px 15px 15px 0;
  margin-left: .8rem;
}

.chat-bubble.question .bubble-content {
  border-radius: 15px 15px 0 15px;
  border: 1px solid #ccc;
  background: #fff;
  margin-right: .8rem;
}

.chat-bubble.answer .bubble-content::before,
.chat-bubble.question .bubble-content::before {
  content: '';
  position: absolute;
  width: 18px;
  height: 18px;
  background-size: contain;
  background-repeat: no-repeat;
  bottom: -1px;
  z-index: -1;
}

.chat-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border-top: 1px solid #ddd;
  padding: 1rem;
  z-index: 10;
  display: flex;
  justify-content: center;
  background: #fff;
}

.chat-footer input {
  width: 100%;
  padding: 13px 60px 13px 13px;
  border: none;
  border-radius: 2rem;
  outline: none;
  font-size: 1rem;
  background: #E2E2E2;
}

.chat-footer button {
  position: absolute;
  width: 40px;
  height: 40px;
  right: 23px;
  bottom: 1.30rem;
  background: transparent linear-gradient(257deg, #e8dd80 0, #009074 100%);
  border: none;
  border-radius: 50%;
}

.chat-footer input:disabled,
.chat-footer button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.star-rating {
  display: inline-flex;
  flex-direction: row-reverse;
  position: absolute;
  bottom: -30px;
  left: 52px;
}

.star {
  cursor: pointer;
}

.star input {
  display: none;
}

.star span::before {
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  content: "\f005";
  font-size: 14px;
  color: #ccc;
  transition: color 0.2s;
  display: inline-block;
  margin-right: 4px;
}

/* .star:hover span::before{
  color: gold;
} */

.star:hover span::before,
.star:hover~.star span::before {
  color: gold;
}

.star input:checked+span::before,
.star input:checked~label span::before {
  color: gold;
}

.loader {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  height: 14px;
}

.loader span {
  width: 8px;
  height: 8px;
  background-color: #999;
  border-radius: 50%;
  animation: blink 1.4s infinite both;
}

.loader span:nth-child(1) {
  animation-delay: 0s;
}

.loader span:nth-child(2) {
  animation-delay: 0.2s;
}

.loader span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0% {
    opacity: 0.2;
  }

  20% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
}
</style>
